"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.costData = {
    "09282020": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "10262020": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "11232020": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "01042021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "02012021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "03012021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "03292021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "04262021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "05242021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "07062021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "08022021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "08302021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "09272021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "10252021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    "11222021": {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "711.5",
        financial__textbooks: "40",
        financial__fees: "243.5"
    },
    costs: {
        program_clockHour: "80 clock hours",
        programLength: "Four (4) weeks",
        financial__tuition: "2000",
        financial__textbooks: "78",
        financial__fees: "0"
    }
};
//# sourceMappingURL=data:application/json;base64,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